export const ADDTOKEN="ADDTOKEN"
export const LOGOUT="LOGOUT"
